import { useViewerStore } from "../state/viewerStore";

export function LoadingOverlay() {
  const loading = useViewerStore((s) => s.loading);
  const progress = useViewerStore((s) => s.loadProgress);
  const error = useViewerStore((s) => s.loadError);

  if (error) {
    return (
      <div className="loading-overlay error">
        <div className="title">Couldn't load the scene</div>
        <div className="msg">{error}</div>
      </div>
    );
  }
  if (!loading) return null;

  const pct = Math.max(0, Math.min(100, Math.round(progress * 100)));
  return (
    <div className="loading-overlay">
      <div className="spinner" />
      <div className="title">Loading scene…</div>
      <div className="bar">
        <div className="fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="msg">{pct}%</div>
    </div>
  );
}
